/**
 *  @Author: qp
 *  @Date: 2023-11-30 09:35:17
 * @Last Modified by: qp
 * @Last Modified time: 2023-12-27 14:29:06
 *  @name 左右联动组件
 **/

import {
  useEffect,
  useRef,
  createContext,
  useContext,
  useState,
  useLayoutEffect,
} from "react";
import { anim } from "@/utils/utils";

const BookContext = createContext();

let contentTop = 0; // 内容区顶部 距离整个页面顶部的距离
let catalogItemPostion = {};
let contentItemPosition = {};
let catalogItemAllRef = {}; // 存储所有的索引项的dom
let contentItemAllRef = {}; // 存储所有的列表项的dom
let contentRef; // 内容区的最外层div， 当数据整个变化后，需要滚动到顶部
let clickScrolling = false; // 点击索引项，滚动中
let reComputing = false; // 是否从新计算中
let initActive; // 重置的索引项，当数据整个变化后， 重置到第一个

export const useBook = ({ defaultActive }) => {
  const [active, setActive] = useState(defaultActive);
  const [scrollTop, setScrollTop] = useState(0);
  initActive = defaultActive;

  // 从新计算， 用途：内容区域后续高度调整后， 需要重新计算高度
  // 本函数调用的时机在：dom变化之后
  const reComputed = (params = {}) => {
    const { isToTop, callback } = params;

    clickScrolling = true; // 即将开始计算了，禁止滚动
    // console.log('isToTop', isToTop);
    if (isToTop) {
      contentRef.scrollTo({ top: 0 }); // 内容区的最外层div， 当数据整个变化后，需要滚动到顶部
      initActive = undefined; // 重置的索引项，当数据整个变化后， 重置到第一个
    } else {
      reComputing = true; // 即将开始计算了，禁止对scrollTop的监听滚动
      setScrollTop(0.1); // 不需要置顶的时候，默认选中其他索引时scrollTop还是0， 点击第一个索引的时候，不会切换，因为监听scrollTop的函数不会执行
    }

    setTimeout(() => {
      // console.log(catalogItemAllRef, Object.keys(catalogItemAllRef))
      Object.keys(catalogItemAllRef).map((item) => {
        getSizeCatalog(item);
      });

      let defaultTop = -1;
      // 这里需要便利索引项， 因为索引项的顺序是正确的
      Object.keys(catalogItemAllRef).map((item, idx) => {
        if (idx === 0) {
          defaultTop = getSizeContent(item, defaultTop);
        } else {
          getSizeContent(item, defaultTop);
        }
      });
      // console.log('contentItemPosition',contentItemPosition);
      if (isToTop) {
        // console.log('setActive', Object.keys(catalogItemPostion)[0]);

        setActive(Object.keys(catalogItemPostion)[0]);
      } else {
        reComputing = false; // 计算完毕，允许滚动
      }
      clickScrolling = false; // 计算完毕，允许滚动
      if (callback) callback();
    }, 100);
  };

  const getSizeCatalog = (id) => {
    // 获取每个索引项的高度
    const { top, height } = catalogItemAllRef[id].getBoundingClientRect();
    catalogItemPostion = {
      ...catalogItemPostion,
      [id]: {
        top,
        height,
      },
    };
  };

  const getSizeContent = (id, defaultTop) => {
    // 获取每个列表项的高度
    const { top, height } = contentItemAllRef[id].getBoundingClientRect();
    let top2 = top;
    let res = 0;
    if (defaultTop) {
      if (defaultTop === -1) {
        if (top !== contentTop) {
          top2 = contentTop;
          res = contentTop - top;
          // console.log(id, top, contentTop,res, contentItemAllRef)
        }
      } else {
        top2 = top + defaultTop;
      }
    }

    contentItemPosition = {
      ...contentItemPosition,
      [id]: {
        top: top2,
        height,
      },
    };

    return res;

    // console.log('contentItemPosition===',contentItemPosition);
  };

  return {
    active,
    setActive,
    scrollTop,
    setScrollTop,
    getSizeCatalog,
    getSizeContent,
    reComputed,
  };
};

export const Catalog = ({ className, children, style = {} }) => {
  const { active, reGet, setReGet } = useContext(BookContext);

  const catalogRef = useRef();

  useEffect(() => {
    // console.log('active', active);
    if (catalogRef.current && active) {
      catalogRef.current.scrollTo({
        top: catalogItemPostion[active]?.top - contentTop,
      });
    }
  }, [active]);

  return (
    <div ref={catalogRef} className={className} style={style}>
      {children}
    </div>
  );
};

export const CatalogItem = ({ className, children, id }) => {
  const { setScrollTop, setActive, getSizeCatalog, active } =
    useContext(BookContext);
  const catalogItemRef = useRef();

  useEffect(() => {
    catalogItemAllRef = {
      ...catalogItemAllRef,
      [id]: catalogItemRef.current,
    };
    getSizeCatalog(id);

    return () => {
      delete catalogItemAllRef[id];
      delete catalogItemPostion[id];
    };
  }, [id]);

  return (
    <div
      ref={catalogItemRef}
      className={className}
      onClick={() => {
        setScrollTop(contentItemPosition[id]?.top - contentTop);
        setActive(id);
      }}
    >
      {children}
    </div>
  );
};

export const Content = ({ className, children, onScroll }) => {
  const { setActive, scrollTop, setScrollTop } = useContext(BookContext);

  const handleScroll = (e) => {
    // console.log('handleScroll',e.target.scrollTop)
    if (clickScrolling || reComputing) return; // 点击索引项后，滚动中则跳过

    const { scrollTop } = e.target;
    const realTop = scrollTop + contentTop;

    const k = Object.keys(contentItemPosition).find((k) => {
      // console.log(
      // 	realTop,
      // 	k,
      // 	contentItemPosition[k]?.top,
      // 	contentItemPosition[k].height,
      // 	realTop >= contentItemPosition[k]?.top &&
      // 		realTop < contentItemPosition[k]?.top + contentItemPosition[k].height
      // );
      return (
        realTop >= contentItemPosition[k]?.top &&
        realTop < contentItemPosition[k]?.top + contentItemPosition[k].height
      );
    });
    // console.log('scroll====', k);
    if (k) {
      setActive(k);
    }

    onScroll && onScroll();
  };
  useLayoutEffect(() => {
    const { top } = contentRef.getBoundingClientRect();
    contentTop = top;
  }, []);
  useEffect(() => {
    // console.log('scrollTop--effect')
    if (reComputing) return; // 从新计算中， 会触发scrollTop值，此时不走这个监听

    clickScrolling = true;
    const st = contentRef.scrollTop;
    // console.log('scrollTop', scrollTop);
    anim(
      contentRef,
      () => {
        setTimeout(() => {
          clickScrolling = false; // 点击索引后的滑动结束
        }, 100);
      },
      st,
      Math.abs(scrollTop - st),
      scrollTop - st > 0 ? 1 : -1,
      false,
      0,
      Math.abs(scrollTop - st) / 40
    );
  }, [scrollTop]);
  return (
    <div
      onScroll={handleScroll}
      ref={(e) => {
        contentRef = e;
      }}
      className={className}
    >
      {children}
    </div>
  );
};

export const ContentItem = ({ className, children, id, style }) => {
  const { getSizeContent } = useContext(BookContext);
  const contentItemRef = useRef();

  useEffect(() => {
    contentItemAllRef[id] = contentItemRef.current;
    getSizeContent(id);

    return () => {
      delete contentItemAllRef[id];
      delete contentItemPosition[id];
    };
  }, [id]);

  return (
    <div ref={contentItemRef} style={{ ...style }} className={className}>
      {children}
    </div>
  );
};

const Book = ({ children, className, book }) => {
  const bookRef = useRef();

  useEffect(() => {
    clickScrolling = false;
  }, []);

  return (
    <BookContext.Provider value={book}>
      <div ref={bookRef} className={className}>
        {children}
      </div>
    </BookContext.Provider>
  );
};

export default Book;
